import { TsDOM as q } from '@/scripts/core/TsDOM'
import { PressMarquee } from '@/scripts/theme/press-marquee'
q.safeDefineElement(PressMarquee)
